import { SVGProps } from "react";

const InfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.9974 18.3334C14.5807 18.3334 18.3307 14.5834 18.3307 10.0001C18.3307 5.41675 14.5807 1.66675 9.9974 1.66675C5.41406 1.66675 1.66406 5.41675 1.66406 10.0001C1.66406 14.5834 5.41406 18.3334 9.9974 18.3334Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1667L10 10.0001"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5L9.99252 7.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default InfoCircle;
